const PostPlaceholder = <template>
  <article class="placeholder">
    <div class="row">
      <div class="topic-avatar">
        <div class="placeholder-avatar placeholder-animation"></div>
      </div>
      <div class="topic-body">
        <div class="placeholder-text placeholder-animation"></div>
        <div class="placeholder-text placeholder-animation"></div>
        <div class="placeholder-text placeholder-animation"></div>
      </div>
    </div>
  </article>
</template>;

export default PostPlaceholder;
